var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [_c('div', [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "移除时间",
      "prop": ""
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "85%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.ruleForm.remove_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "remove_date", $$v)
      },
      expression: "ruleForm.remove_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "操作人",
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "85%"
    },
    model: {
      value: (_vm.$globals.user.name),
      callback: function($$v) {
        _vm.$set(_vm.$globals.user, "name", $$v)
      },
      expression: "$globals.user.name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "移除原因",
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "85%"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入移除原因"
    },
    model: {
      value: (_vm.ruleForm.remove_reason),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "remove_reason", $$v)
      },
      expression: "ruleForm.remove_reason"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "80px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f557377","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Hmdgl/Hmdgl_yichu.vue
// module id = null
// module chunks = 